(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["corl-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.corl-size-guide');

    sections.forEach((section) => {
      if (section.dataset.corlSizeGuideInitialized === 'true') return;
      section.dataset.corlSizeGuideInitialized = 'true';

      const flipButton = section.querySelector('.corl-size-guide__figure');
      const frontImage = flipButton?.querySelector('.corl-size-guide__image--front');
      const backImage = flipButton?.querySelector('.corl-size-guide__image--back');
      const unitButtons = section.querySelectorAll('[data-unit]');
      const tabButtons = section.querySelectorAll('[data-target]');
      const panels = section.querySelectorAll('[data-panel]');
      const cells = section.querySelectorAll('[data-cm]');

      const setUnit = (unit) => {
        unitButtons.forEach((button) => {
          const active = button.dataset.unit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        cells.forEach((cell) => {
          const centimeters = Number.parseFloat(cell.dataset.cm);
          if (!Number.isFinite(centimeters)) return;
          cell.textContent = unit === 'inch' ? (centimeters / 2.54).toFixed(1) : String(Math.round(centimeters * 10) / 10);
        });
      };

      const setTab = (target) => {
        tabButtons.forEach((button) => {
          const active = button.dataset.target === target;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
        });
        panels.forEach((panel) => {
          const active = panel.dataset.panel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      if (flipButton) {
        let pointerStartX = null;
        let lastSwipeAt = 0;
        const mobileMedia = window.matchMedia('(max-width: 749px)');

        const setFlip = (showBack) => {
          flipButton.setAttribute('aria-pressed', String(showBack));
          flipButton.setAttribute('aria-label', showBack ? flipButton.dataset.frontLabel : flipButton.dataset.backLabel);
          frontImage?.setAttribute('aria-hidden', String(showBack));
          backImage?.setAttribute('aria-hidden', String(!showBack));
        };

        const updateFigureMode = () => {
          const isMobile = mobileMedia.matches;
          flipButton.disabled = !isMobile;
          if (!isMobile) {
            setFlip(false);
            frontImage?.removeAttribute('aria-hidden');
            backImage?.removeAttribute('aria-hidden');
          }
        };

        flipButton.addEventListener('pointerdown', (event) => {
          if (mobileMedia.matches && event.pointerType === 'touch') pointerStartX = event.clientX;
        });
        flipButton.addEventListener('pointerup', (event) => {
          if (!mobileMedia.matches || pointerStartX === null || event.pointerType !== 'touch') return;
          const distance = event.clientX - pointerStartX;
          pointerStartX = null;
          if (Math.abs(distance) < 40) return;
          setFlip(distance < 0);
          lastSwipeAt = Date.now();
        });
        flipButton.addEventListener('pointercancel', () => { pointerStartX = null; });
        flipButton.addEventListener('click', () => {
          if (!mobileMedia.matches) return;
          if (Date.now() - lastSwipeAt < 500) return;
          setFlip(flipButton.getAttribute('aria-pressed') !== 'true');
        });
        updateFigureMode();
        mobileMedia.addEventListener('change', updateFigureMode);
      }
      unitButtons.forEach((button) => button.addEventListener('click', () => setUnit(button.dataset.unit)));
      tabButtons.forEach((button) => button.addEventListener('click', () => setTab(button.dataset.target)));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["genesis-mobile-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedAttribute = 'data-genesis-carousel-pagination-initialized';

    const initializeCarouselPagination = (carousel) => {
      if (carousel.hasAttribute(initializedAttribute)) return;

      const pagination = carousel.nextElementSibling;
      const slides = Array.from(carousel.children).filter((slide) => slide.getAttribute('role') === 'listitem');

      if (
        !(pagination instanceof HTMLElement) ||
        !pagination.hasAttribute('data-genesis-carousel-pagination') ||
        slides.length < 2
      ) {
        return;
      }

      carousel.setAttribute(initializedAttribute, '');

      const bars = slides.map(() => {
        const bar = document.createElement('span');
        bar.className = 'genesis-mobile-home__carousel-pagination-bar';
        pagination.append(bar);
        return bar;
      });

      let activeIndex = -1;
      let animationFrame;

      const updateActiveSlide = () => {
        animationFrame = undefined;

        const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        const scrollPosition = carousel.scrollLeft;
        const firstSlideOffset = slides[0].offsetLeft;
        const slideAnchors = slides.map((slide) => Math.min(maxScroll, Math.max(0, slide.offsetLeft - firstSlideOffset)));

        let nextIndex;

        if (scrollPosition <= 1 || maxScroll === 0) {
          nextIndex = 0;
        } else if (scrollPosition >= maxScroll - 1) {
          nextIndex = slides.length - 1;
        } else {
          nextIndex = slideAnchors.reduce(
            (closestIndex, anchor, index) => {
              const closestDistance = Math.abs(slideAnchors[closestIndex] - scrollPosition);
              const distance = Math.abs(anchor - scrollPosition);
              return distance < closestDistance ? index : closestIndex;
            },
            0
          );
        }

        if (nextIndex === activeIndex) return;

        bars[activeIndex]?.classList.remove('is-active');
        bars[nextIndex]?.classList.add('is-active');
        activeIndex = nextIndex;
      };

      const requestUpdate = () => {
        if (animationFrame) return;
        animationFrame = window.requestAnimationFrame(updateActiveSlide);
      };

      carousel.addEventListener('scroll', requestUpdate, { passive: true });
      carousel.addEventListener('scrollend', requestUpdate);

      if ('ResizeObserver' in window) {
        new ResizeObserver(requestUpdate).observe(carousel);
      } else {
        window.addEventListener('resize', requestUpdate, { passive: true });
      }

      requestUpdate();
    };

    const lightboxInitializedAttribute = 'data-genesis-lightbox-initialized';

    const initializeLightbox = (section, lightbox) => {
      if (
        !(section instanceof HTMLElement) ||
        !(lightbox instanceof HTMLElement) ||
        lightbox.hasAttribute(lightboxInitializedAttribute)
      ) {
        return;
      }

      const lightboxGroup = lightbox.dataset.genesisLightboxGroup;
      const triggers = Array.from(section.querySelectorAll('[data-genesis-lightbox-trigger]')).filter(
        (trigger) => trigger.dataset.genesisLightboxGroup === lightboxGroup
      );

      if (triggers.length === 0) return;

      const image = lightbox.querySelector('[data-genesis-lightbox-image]');
      const closeButton = lightbox.querySelector('[data-genesis-lightbox-close]');
      const previousButton = lightbox.querySelector('[data-genesis-lightbox-previous]');
      const nextButton = lightbox.querySelector('[data-genesis-lightbox-next]');

      if (
        !(image instanceof HTMLImageElement) ||
        !(closeButton instanceof HTMLButtonElement) ||
        !(previousButton instanceof HTMLButtonElement) ||
        !(nextButton instanceof HTMLButtonElement)
      ) {
        return;
      }

      lightbox.setAttribute(lightboxInitializedAttribute, '');

      let activeIndex = 0;
      let triggerBeforeOpen;
      let bodyOverflow = '';
      let touchStart;

      const showImage = (index) => {
        activeIndex = (index + triggers.length) % triggers.length;
        const trigger = triggers[activeIndex];

        image.src = trigger.dataset.genesisLightboxSrc || trigger.querySelector('img')?.currentSrc || '';
        image.alt = trigger.dataset.genesisLightboxAlt || '';
      };

      const openLightbox = (index, trigger) => {
        triggerBeforeOpen = trigger;
        showImage(index);
        bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        lightbox.hidden = false;
        closeButton.focus({ preventScroll: true });
      };

      const closeLightbox = () => {
        if (lightbox.hidden) return;

        lightbox.hidden = true;
        image.removeAttribute('src');
        document.body.style.overflow = bodyOverflow;
        triggerBeforeOpen?.focus({ preventScroll: true });
      };

      const showPreviousImage = () => showImage(activeIndex - 1);
      const showNextImage = () => showImage(activeIndex + 1);

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => openLightbox(index, trigger));
      });

      closeButton.addEventListener('click', closeLightbox);
      previousButton.addEventListener('click', showPreviousImage);
      nextButton.addEventListener('click', showNextImage);

      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });

      lightbox.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.changedTouches[0];
          touchStart = touch ? { x: touch.clientX, y: touch.clientY } : undefined;
        },
        { passive: true }
      );

      lightbox.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          if (!touchStart || !touch) return;

          const horizontalDistance = touch.clientX - touchStart.x;
          const verticalDistance = touch.clientY - touchStart.y;
          touchStart = undefined;

          if (Math.abs(horizontalDistance) < 48 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;
          if (horizontalDistance > 0) showPreviousImage();
          else showNextImage();
        },
        { passive: true }
      );

      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showPreviousImage();
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showNextImage();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableControls = [closeButton, previousButton, nextButton];
        const currentIndex = focusableControls.indexOf(document.activeElement);
        const nextIndex = event.shiftKey
          ? (currentIndex - 1 + focusableControls.length) % focusableControls.length
          : (currentIndex + 1) % focusableControls.length;

        event.preventDefault();
        focusableControls[nextIndex].focus();
      });
    };

    const initializeAll = (root = document) => {
      const carousels = root.querySelectorAll?.('[data-genesis-carousel]') || [];
      carousels.forEach(initializeCarouselPagination);

      const sections = root.matches?.('.genesis-mobile-home, .genesis-desktop-home')
        ? [root]
        : root.querySelectorAll?.('.genesis-mobile-home, .genesis-desktop-home') || [];
      sections.forEach((section) => {
        section.querySelectorAll('[data-genesis-lightbox]').forEach((lightbox) => initializeLightbox(section, lightbox));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
